export default "__VITE_ASSET__ad36874c__"